import React from "react";
import "../style/debtPayOff.css";
import NewLoader from "../../../styled-components/loader/NewLoader";
import { Line } from "react-chartjs-2";
import moment from "moment";

export const PayOffProgress = (props) => {
  const detailsData = [
    {
      id: 1,
      name: "Principal Paid",
      time:
        props.totalPaid &&
        props.totalPaid &&
        props.totalPaid.totalPrincipalPaidSum &&
        `${
          "$" +
          props.totalPaid.totalPrincipalPaidSum
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }`,
    },
    {
      id: 2,
      name: "Balance",
      time:
        props.totalPaid &&
        props.totalPaid &&
        props.totalPaid.totalRemainingBalance &&
        `${
          "$" +
          props.totalPaid.totalRemainingBalance
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }`,
    },
  ];
  const chartData = [];
  const chartDataInterest = [];
  const chartDataPrincipal = [];

  // Iterate over the data to extract unique values
  props.data && props.data.forEach(item => {
    // Extract and format the month data if available
    if (item.month && item.month !==undefined) {
      const formattedMonth = moment(item.month).format("MM-DD-YYYY");
      if (!chartData.includes(formattedMonth)) {
        chartData.push(formattedMonth);
      }
    }

    // Extract unique interest payments
    if (item.interestPayment !== undefined ) {
      chartDataInterest.push(item.interestPayment);
    }

    // Extract unique principal payments
    if (item.principalPaid !== undefined ) {
      chartDataPrincipal.push(item.principalPaid);
    }
  });
  // const chartData = [
  //   ...new Set(
  //     props.data &&
  //       props.data.map(
  //         (item) => item.month && moment(item.month).format("MM-DD-YYYY")
  //       )
  //   ),
  // ];
  // const chartDataInterest = [
  //   ...new Set(
  //     props.data &&
  //       props.data.map((item) =>
  //         item.interestPayment !== undefined ? item.interestPayment : 0
  //       )
  //   ),
  // ];

  // const chartDataPrincipal = [
  //   ...new Set(
  //     props.data &&
  //       props.data.map((item) =>
  //         item.principalPaid !== undefined ? item.principalPaid : 0
  //       )
  //   ),
  // ];
  // console.log("chartData", props.data && props.data,chartData, chartDataInterest, chartDataPrincipal);
  const data = {
    labels: chartData && chartData ,// ["12-04-2024", "13-04-2024", "14-04-2024"],
    datasets: [
      {
        label: "Total Principal",
        data: chartDataPrincipal && chartDataPrincipal,  //[345,678,500],
        fill: true,
        backgroundColor: "#156082",
        borderColor: "#156082",
      },
      {
        label: "Total Interest",
        data:  chartDataInterest && chartDataInterest, //[415,728,500],
        fill: true,
        backgroundColor: "#E97132",
        borderColor: "#E97132",
      },
    ],
  };
  return (
    <div style={{ position: "relative" }}>
      {" "}
      <div className="cardHeadingWhite">Payoff Progress</div>
      <div style={{}}>
        <div
          className="listingContainer"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            // width:"50%"
          }}
        >
          <React.Fragment>
            {detailsData && detailsData.length > 0 ? (
              detailsData.map((item, index) => (
                <div
                  key={index}
                  className="list-row-no"
                  style={{ marginTop: "1rem" }}
                >
                  <div className="listname-dark">
                    <div style={{ color: "white" }}>{item.name}</div>
                    <div style={{ color: "white" }}>{item.time}</div>
                  </div>
                </div>
              ))
            ) : (
              <div className="nodata">No data to show</div>
            )}
          </React.Fragment>
        </div>
        <div
          className="listingContainer"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            // background:"white"
          }}
        >
          <React.Fragment>
            <Line
              data={data}
              options={{
                legend: {
                  display: true,
                  labels: {
                    fontColor: "white",
                  },
                },
                scales: {
                  xAxes: [
                    {
                      gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                      },
                      ticks: {
                        fontColor: "white",
                        stepSize: 1,
                        beginAtZero: true,
                      },
                    },
                  ],
                  yAxes: [
                    {
                      gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                      },
                      ticks: {
                        fontColor: "white",
                        stepSize: 1,
                        beginAtZero: true,
                      },
                    },
                  ],
                },
                plugins: {},
              }}
            />
          </React.Fragment>
        </div>
      </div>
      <NewLoader isLoading={props.loading} />
    </div>
  );
};
